function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formErrorAnatomy as parts } from "@chakra-ui/anatomy";
import { chakra, forwardRef } from "@chakra-ui/react";
import { WarningIcon } from "@tempo/icons";
import { FormErrorMessage as ChakraFormErrorMessage } from "@chakra-ui/react";
const baseStyleText = ()=>{
    return {
        color: 'red.500',
        mt: 2,
        fontSize: 'sm',
        lineHeight: 'normal'
    };
};
const baseStyle = (props)=>({
        text: baseStyleText(props)
    });
export const ThemedFormError = {
    parts: parts.keys,
    baseStyle
};
export const FormErrorIcon = chakra(WarningIcon, {
    baseStyle: {
        mr: 2
    }
});
export const FormErrorMessage = forwardRef((_param, ref)=>{
    var { icon = /*#__PURE__*/ _jsx(FormErrorIcon, {}), children } = _param, props = _object_without_properties(_param, [
        "icon",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(ChakraFormErrorMessage, _object_spread_props(_object_spread({
        icon: /*#__PURE__*/ _jsx(FormErrorIcon, {}),
        ref: ref
    }, props), {
        children: [
            icon,
            " ",
            children
        ]
    }));
});

//# sourceMappingURL=FormError.js.map